import { createSubstore } from 'storeon-substore';
import { ApiException } from 'api/api-exeption';
import type { Store } from 'store/types';
import { getModel } from './model-json-actions';
import { FETCH_MODEL, MODEL_RESET, MODEL_JSON_STORE_NAME } from './model-json-constants';
import { ModelJsonStore } from './model-json-types';

const INITIAL_STATE: ModelJsonStore = {
  model: null,
  loading: false,
  error: null,
  errorStatus: null,
} as const;

export const modelJson = (parentStore: Store) => {
  const store = createSubstore(parentStore, MODEL_JSON_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(FETCH_MODEL.init, async (_, { host, url }) => {
    const { loading } = store.get();

    if (loading) return Promise.resolve();

    store.dispatch(FETCH_MODEL.request);

    try {
      const model = await getModel(host, url, parentStore);
      store.dispatch(FETCH_MODEL.success, model);
    } catch (e) {
      store.dispatch(FETCH_MODEL.failure, {
        error: (e as ApiException).message,
        errorStatus: (e as ApiException).status,
      });
    }

    return Promise.resolve();
  });
  store.on(FETCH_MODEL.setModelState, (_, modelJsonState) => ({ ...modelJsonState }));
  store.on(FETCH_MODEL.request, state => ({ ...state, loading: true }));
  store.on(FETCH_MODEL.failure, (state, error) => ({
    ...state,
    ...error,
    loading: false,
  }));
  store.on(FETCH_MODEL.success, (state, res) => ({
    ...state,
    model: res,
    error: null,
    errorStatus: null,
    loading: false,
  }));
  store.on(MODEL_RESET, () => INITIAL_STATE);
};
